/*
  Pedlock: autoplay videos further down the page (snippets/media.liquid) start
  with no file at all. When one comes within NEAR px of the screen it gets its
  poster and the smallest MP4 that still looks sharp at the size it is shown
  (pixel density capped at 2), so phones load a 480p or 720p copy instead of
  1080p. If that copy doesn't exist for a video, the next larger one is tried,
  ending with the file Liquid listed.
  Playing and pausing as the video scrolls in and out of view is still done by
  the theme's video store (video.js); this only supplies the file in time.
*/
(() => {
  if (window.plLazyVideo) return;
  window.plLazyVideo = true;

  const NEAR = 800;

  const readSources = (video) => {
    try {
      return JSON.parse(video.dataset.plSources || '[]').sort((a, b) => a.w - b.w);
    } catch (e) {
      return [];
    }
  };

  const firstSharpEnough = (video, sources) => {
    const shown = video.clientWidth || (video.parentElement && video.parentElement.clientWidth) || 360;
    const needed = shown * Math.min(window.devicePixelRatio || 1, 2) * 0.8;
    const index = sources.findIndex((source) => source.w >= needed);
    return index === -1 ? sources.length - 1 : index;
  };

  const isOnScreen = (video) => {
    const rect = video.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.width > 0;
  };

  // After a fast jump the theme may try to start the video in the same frame
  // the file is set, and setting the file cancels that start, so an autoplay
  // video already on screen is started here
  const resume = (video) => {
    const container = video.closest('.external-video');
    if (container && container.dataset.videoAutoPlay === 'true' && video.paused && isOnScreen(video)) {
      video.play().catch(() => {});
    }
  };

  const prepare = (video) => {
    if (video.dataset.plReady) return;
    video.dataset.plReady = 'true';
    if (video.dataset.plPoster) video.poster = video.dataset.plPoster;

    const sources = readSources(video);
    if (!sources.length) return;
    let current = firstSharpEnough(video, sources);

    video.addEventListener('error', () => {
      if (current >= sources.length - 1) return;
      current += 1;
      video.src = sources[current].u;
      resume(video);
    });

    video.src = sources[current].u;
    resume(video);
  };

  const isNear = (video) => {
    const rect = video.getBoundingClientRect();
    return rect.bottom > -NEAR && rect.top < window.innerHeight + NEAR;
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              prepare(entry.target);
            });
          },
          { rootMargin: NEAR + 'px 0px' }
        )
      : null;

  const scan = (root) => {
    (root || document).querySelectorAll('video[data-pl-lazy-video]:not([data-pl-ready])').forEach((video) => {
      // Videos already near the screen get their file before the theme starts them
      if (!observer || isNear(video)) {
        prepare(video);
      } else {
        observer.observe(video);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }
  // Sections re-rendered in the theme editor
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
